import { createReducer } from 'common/utils/reducerUtils';
import {
  LOAD_SETTINGS_SUCCESS,
  LOAD_SETTINGS_FAILURE,
  OPEN_USER_SETTINGS_DIALOG,
  RESET_USER_SETTINGS_DIALOG,
  LOAD_USER_SUCCESS,
  LOAD_USER_FAILURE,
  OPEN_SIGNIN_DIALOG,
  CLOSE_SIGNIN_DIALOG,
} from './settingConstants';
import { LOGOUT_SUCCESS } from '../auth/authConstants';

const initialState = {
  funds: [],
  isLoaded: false,
  fieldsByCategory: {},
  tradeLabel: 'Idea',
  routes: [],
  user:{},
  helpModal: {
    isOpened: false
  },
  userSettingModal: {
    isOpened: false,
    user: null
  },
  signInModal: {
    isOpened: false,
    user: null
  },
};


export function loadSettingsSuccess(state, payload) {
  return {
    ...state,
    isLoaded: true,
    user: payload
  };
}

export function loadSettingsFailure(state, payload) {
  return {
    ...initialState,
    isLoaded: true
  };
}

export function logoutSuccess() {
  return {
    ...initialState
  };
}

export function requestLoadSettings(state) {
  return initialState;
}

export function openUserSettingDialog(state) {
  return {
    ...state,
    userSettingModal: {
      ...state.userSettingModal,
      isOpened: true
    }
  };
}

export function openSignInDialog(state) {
  return {
    ...state,
    signInModal: {
      ...state.signInModal,
      isOpened: true
    }
  };
}

export function resetUserSettingDialog(state) {
  return {
    ...state,
    userSettingModal: {
      ...state.userSettingModal,
      isOpened: false
    }
  };
}

export function closeSignInDialog(state) {
  return {
    ...state,  // 保留原有状态
    signInModal: {
      ...state.signInModal,  // 保留 signInModal 中的其他属性
      isOpened: false  // 关闭登录对话框
    }
  };
}

export function loadUserSuccess(state, payload) {
  return {
    ...state,
    userSettingModal: {
      ...state.userSettingModal,
      user: payload
    }
  };
}

export function loadUserFailure(state, payload) {
  return {
    ...initialState,
  };
}

export default createReducer(initialState, {
  [LOAD_SETTINGS_SUCCESS]: loadSettingsSuccess,
  [LOAD_SETTINGS_FAILURE]: loadSettingsFailure,
  [LOGOUT_SUCCESS]: logoutSuccess,
  [OPEN_USER_SETTINGS_DIALOG]: openUserSettingDialog,
  [OPEN_SIGNIN_DIALOG]: openSignInDialog,
  [RESET_USER_SETTINGS_DIALOG]: resetUserSettingDialog,
  [CLOSE_SIGNIN_DIALOG]: closeSignInDialog,
  [LOAD_USER_SUCCESS]: loadUserSuccess,
  [LOAD_USER_FAILURE]: loadUserFailure,
});
